<template>
  <div>
    <generic-modal
      v-if="dataOnboardingAnimation"
      :height="AnimationModalDim.height"
      :width="AnimationModalDim.width"
      :padding="AnimationModalDim.padding"
      :modalClass="AnimationModalDim.modalClass"
      :overflowNotNeeded="false"
    >
      <template v-slot:body>
        <VueLottiePlayer
          name="onboardingAnim"
          loop
          :animationData="require('../assets/onboarding-animation.json')"
          width="100vw"
          height="100vh"
          id="onboardingAnimationContainer"
        />
      </template>
    </generic-modal>
    <generic-modal
      v-else
      :height="LoginModalDim.height"
      :width="LoginModalDim.width"
      :padding="LoginModalDim.padding"
      :modalClass="LoginModalDim.modalClass"
      overflowNotNeeded="true"
    >
      <template v-slot:header>
        <div></div>
      </template>
      <template v-slot:body>
        <img
          :src="staticImgBaseUrl + '/images/global/hongs-default-img-lg.png'"
          alt="hongs-kitchen-icon"
          class="onboarding-logo"
        />
        <img
          :src="
            staticImgBaseUrl + '/images/global/logo-hongs-kitchen-wordmark.svg'
          "
          alt="hongs-kitchen-icon"
          class="onboarding-logo-label"
        />
      </template>
      <template v-slot:footer>
        <div class="onboarding-footer">
          <img
            :src="staticImgBaseUrl + '/images/global/jubilant-icon.svg'"
            alt="jubilant-icon"
            class="mr8"
          />
          <span>Jubilant FoodWorks</span>
        </div>
      </template>
    </generic-modal>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
import GenericModal from "./GenericModal.vue";
import { staticImgBaseUrl } from "../config/apiEndpoints";
export default {
  name: "Onboarding",
  components: {
    GenericModal,
    VueLottiePlayer: defineAsyncComponent(() => import("vue-lottie-player")),
  },
  props: {
    dataOnboardingAnimation: {
      required: false,
      default: false,
    },
  },
  data() {
    return {
      LoginModalDim: {
        width: "100vw",
        height: "100vh",
        padding: "0px",
        modalClass: "login-modal full-screen-popup  lg-screen-centered",
      },
      AnimationModalDim: {
        width: "100vw",
        height: "100vh",
        padding: "0px",
        modalClass:
          "animation-full-modal full-screen-popup  lg-screen-centered",
      },
      staticImgBaseUrl: staticImgBaseUrl,
      rendererSettings: {
        preserveAspectRatio: "xMidYMid slice",
      },
    };
  },
  mounted() {
    setTimeout(this.setSvgPreserveAspectRatio, 50);
  },
  methods: {
    setSvgPreserveAspectRatio() {
      const parentElement = document.getElementById(
        "onboardingAnimationContainer"
      );
      if (parentElement) {
        const svgElement = parentElement.querySelector("svg");
        if (svgElement) {
          svgElement.setAttribute("preserveAspectRatio", "xMidYMid slice");
        }
      } else {
        setTimeout(this.setSvgPreserveAspectRatio, 50);
      }
    },
  },
};
</script>
